export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

export const shouldUseDryRun = (): boolean => {
  // Use dry run in development and staging, but not in production
  return !isProduction();
};

export const getEnvironment = (): string => {
  return process.env.NODE_ENV || 'production';
};

// Get environment from config if available
export const getEnvironmentFromConfig = (): string => {
  // You can add environment detection logic here based on config values
  return getEnvironment();
}; 